import script from "./MainContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainContent.vue?vue&type=script&lang=ts&setup=true"

import "./MainContent.vue?vue&type=style&index=0&id=1f2a8c7c&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2a8c7c"]])

export default __exports__